import {Box, Container} from '@mui/material';
import type * as React from 'react';

const Home = (): React.ReactElement => {
    return (
        <Container maxWidth='sm'>
            <Box sx={{typography: 'h4', textAlign: 'center', mt: 3, color: '#fff'}}>
                QR Login System
            </Box>
        </Container>
    );
};

export default Home;
